<div class="daf-modal">
  <div class="daf-modal-header">
    <div class="header-label">{{ formTitle }}</div>
    <div class="header-actions">
      <button class="daf-close-btn" aria-label="Close" (click)="closeModal()">
        <svg class="icon-set">
          <use [attr.xlink:href]="'./assets/images/icons.svg#close'"></use>
        </svg>
      </button>
    </div>
  </div>
  <div class="daf-modal-body">
    <!-- Section Navigation with Tabs -->
    <div *ngIf="sections.length > 1" class="daf-section-navigation">
      <div class="daf-section-tabs">
        <button *ngFor="let section of sections; let i = index" type="button" class="daf-section-tab"
          [class.daf-active-tab]="currentSectionIndex === i" (click)="goToSection(i)">
          {{ section.name }}
        </button>
      </div>
    </div>
    <div *ngIf="!isSchemaAvailable">
      Schema invalid
    </div>
    <div class="daf-form-content daf-horizontal-scroll" *ngIf="isSchemaAvailable" [ngClass]="{
      'section-content': (sections && sections.length > 1)
    }">


      <ng-container *ngIf="selectedTabType == 'basic' || selectedTabType == 'advanced'">
        <div class="daf-fields-panel">
          <ng-container *ngFor="let item of schemaHash.properties | keyvalue:keepOrder;">
            <div class="daf-field-row" *ngIf="item.value && $any(item.value).hidden !== true" [ngClass]="{
              'daf-field-row--inline': (item.value && $any(item.value).type && ($any(item.value).type == 'boolean' || ($any(item.value).type == 'string' && ($any(item.value).component == 'color' || $any(item.value).component == 'button-group'))))
            }">
              <div class="daf-input-details">
                <div class="daf-input-title"
                  *ngIf="item.value && $any(item.value).label && $any(item.value).label != ''">
                  {{$any(item.value).label}}
                  <span class="daf-input-title-required" *ngIf="$any(item.value).required">*</span>
                </div>
                <div class="daf-input-description"
                  *ngIf="$any(item.value).description && $any(item.value).description != '' && $any(item.value).component !== 'label'">
                  {{$any(item.value).description}}
                </div>
              </div>

              <div class="daf-field-control">
                <ng-container *ngIf="item.value && $any(item.value).type && $any(item.value).type == 'string'">
                  <input class="form-input" [disabled]="readonly" [ngClass]="{'error': formErrors[$any(item).key]}"
                    [placeholder]="($any(item.value).placeholder)?$any(item.value).placeholder: ('Provide '+ $any(item.value).label +'....')"
                    (keyup)="onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])"
                    *ngIf="$any(item.value).multiline !== true && (!$any(item.value).component || $any(item.value).component == '')"
                    type="text" [(ngModel)]="dataHash[$any(item).key]">

                  <div class="daf-label-note" *ngIf="$any(item.value).component == 'label'">
                    {{ $any(item.value).description || $any(item.value).text || '' }}
                  </div>

                  <label class="daf-color-swatch" *ngIf="$any(item.value).component == 'color'"
                    [class.error]="formErrors[$any(item).key]"
                    [attr.title]="$any(item.value).label || 'Pick color'">
                    <input type="color" [disabled]="readonly" class="daf-color-input"
                      [(ngModel)]="dataHash[$any(item).key]"
                      (input)="onFormValueChange($any(item.value), $any(item).key, $event, dataHash[$any(item).key])"
                      (change)="onFormValueChange($any(item.value), $any(item).key, $event, dataHash[$any(item).key])">
                  </label>

                  <textarea [disabled]="readonly" class="form-textarea" [ngClass]="{'error': formErrors[$any(item).key]}"
                    [placeholder]="($any(item.value).placeholder)?$any(item.value).placeholder: ('Provide '+ $any(item.value).label+'....')"
                    (keyup)="onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])"
                    *ngIf="$any(item.value).multiline == true" [(ngModel)]="dataHash[$any(item).key]"></textarea>

                  <div class="custom-dropdown" *ngIf="$any(item.value).component == 'dropdown'"
                    [class.open]="isDropdownOpen('schema-' + $any(item).key)" [class.error]="formErrors[$any(item).key]"
                    [class.disabled]="$any(item.value).disabled" [class.has-value]="!!dataHash[$any(item).key]">
                    <button  type="button" class="custom-dropdown-toggle" [disabled]="$any(item.value).disabled || readonly"
                      (click)="!$any(item.value).disabled && toggleDropdown('schema-' + $any(item).key, $event)">
                      <span class="custom-dropdown-label" [class.is-placeholder]="!dataHash[$any(item).key]">{{
                        getDropdownLabel(getSchemaDropdownOptions($any(item.value)), dataHash[$any(item).key],
                        $any(item.value).placeholder || 'Select an option') }}</span>
                      <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                    </button>
                    <ul class="custom-dropdown-menu"
                      *ngIf="isDropdownOpen('schema-' + $any(item).key) && !$any(item.value).disabled">
                      <li class="custom-dropdown-item custom-dropdown-item--placeholder"
                        [class.active]="!dataHash[$any(item).key]"
                        (click)="onCustomSelect('schema-' + $any(item).key, '', 'schemaDropdown', $any(item).key, $any(item.value)); $event.stopPropagation()">
                        {{ $any(item.value).placeholder || 'Select an option' }}
                      </li>
                      <li class="custom-dropdown-item" *ngFor="let option of getSchemaDropdownOptions($any(item.value))"
                        [class.active]="dataHash[$any(item).key] == option.id"
                        (click)="onCustomSelect('schema-' + $any(item).key, option.id, 'schemaDropdown', $any(item).key, $any(item.value)); $event.stopPropagation()">
                        <span class="custom-dropdown-item-text">{{ option.name }}</span>
                        <span class="custom-dropdown-check" *ngIf="dataHash[$any(item).key] == option.id"
                          aria-hidden="true">✓</span>
                      </li>
                    </ul>
                  </div>

                  <div class="daf-field-note" *ngIf="$any(item.value).note">
                    {{ $any(item.value).note }}
                  </div>

                  <div class="daf-button-group" *ngIf="$any(item.value).component == 'button-group'">
                    <button [disabled]="readonly" type="button" *ngFor="let option of $any(item.value).options"
                      [ngClass]="{'active': dataHash[$any(item).key] == (($any(item.value).valueField)?option[$any(item.value).valueField]:option.value)}"
                      (click)=" dataHash[$any(item).key] = (($any(item.value).valueField)?option[$any(item.value).valueField]:option.value); onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])">
                      {{option[$any(item.value).textField] || option.label || option.text || option}}
                    </button>
                  </div>
                </ng-container>

                <input [disabled]="readonly" class="form-input" [ngClass]="{'error': formErrors[$any(item).key]}"
                  (keyup)="onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])"
                  *ngIf="item.value && $any(item.value).type && $any(item.value).type == 'number'" type="number"
                  [(ngModel)]="dataHash[$any(item).key]">

                <div class="property-toggle"
                  *ngIf="item.value && $any(item.value).type && $any(item.value).type == 'boolean'">
                  <input [disabled]="readonly" type="checkbox"
                    (change)="onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])"
                    [(ngModel)]="dataHash[$any(item).key]" *ngIf="$any(item.value).component !== 'switch'">
                  <label class="switch" *ngIf="$any(item.value).component === 'switch'">
                    <input [disabled]="readonly" type="checkbox"
                      (change)="onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])"
                      [(ngModel)]="dataHash[$any(item).key]">
                    <span class="slider round"></span>
                  </label>
                </div>

                <div class="daf-checkbox-group-container"
                  *ngIf="item.value && $any(item.value).type && $any(item.value).type == 'array' && $any(item.value).component == 'checkbox-group'"
                  [class.error]="formErrors[$any(item).key]">
                  <label class="daf-checkbox-group-item"
                    *ngFor="let option of $any(item.value).options"
                    [class.is-checked]="dataHash[$any(item).key] && dataHash[$any(item).key][option.id]">
                    <input [disabled]="readonly" type="checkbox"
                      [(ngModel)]="dataHash[$any(item).key][option.id]"
                      [value]="option.id"
                      (change)="onFormValueChange($any(item.value), $any(item).key, $event, dataHash[$any(item).key])">
                    <span class="daf-checkbox-label">{{ option.name }}</span>
                  </label>
                </div>

                <div
                  *ngIf="item.value && $any(item.value).type && $any(item.value).type == 'list' && $any(item.value).component == 'multi-select'"
                  class="daf-multiselect-container" [class.disabled]="$any(item.value).disabled"
                  [attr.data-multiselect-key]="$any(item).key">
                  <div class="daf-multiselect-button" [ngClass]="{'error': formErrors[$any(item).key],'disabled': readonly}"
                    (click)="toggleMultiSelect(item.value, $event)" [class.open]="$any(item.value).isOpen">
                    <div class="daf-multiselect-button-text">
                      <div class="daf-multiselect-selected"
                        *ngIf="dataHash[$any(item).key] && dataHash[$any(item).key].length > 0">
                        <div class="daf-multiselect-tag" *ngFor="let selected of dataHash[$any(item).key]">
                          <span>{{ getMultiSelectSelectedLabel(selected, $any(item.value)) }}</span>
                          <img *ngIf="!readonly" src="assets/images/close.svg"
                            (click)="removeMultiSelectOption(item, selected, $any(item.value).uniqueIdField || $any(item.value).valueField, $event)"
                            class="daf-multiselect-remove" alt="">
                        </div>
                      </div>
                      <div class="daf-multiselect-placeholder"
                        *ngIf="!(dataHash[$any(item).key] && dataHash[$any(item).key].length > 0)">
                        {{ $any(item.value).placeholder || 'Select options' }}
                      </div>
                    </div>
                    <img class="daf-multiselect-arrow" [ngClass]="{'rotate-180': $any(item.value).isOpen}"
                      src="assets/images/down-arrow.svg" alt="">
                  </div>
                  <div class="daf-multiselect-dropdown" *ngIf="$any(item.value).isOpen"
                    (click)="$event.stopPropagation()">
                    <div class="daf-multiselect-search">
                      <input type="text" class="daf-multiselect-search-input" placeholder="Search..."
                        [(ngModel)]="$any(item.value).searchText" (ngModelChange)="$any(item.value).searchText = $event"
                        (click)="$event.stopPropagation()">
                    </div>
                    <ul class="daf-multiselect-list">
                      <li *ngFor="let option of filterMultiSelectOptions(item.value, $any(item.value).searchText)"
                        (click)="selectMultiSelectOption(item, option, $any(item.value).uniqueIdField || $any(item.value).valueField); $event.stopPropagation(); onFormValueChange($any(item.value),$any(item).key,$event,dataHash[$any(item).key])"
                        [class.selected]="isMultiSelectOptionSelected(item, option, $any(item.value).uniqueIdField || $any(item.value).valueField)">
                        <img
                          *ngIf="!isMultiSelectOptionSelected(item, option, $any(item.value).uniqueIdField || $any(item.value).valueField)"
                          src="assets/images/checkbox-blank-outline.svg" class="daf-multiselect-checkbox" alt="">
                        <img
                          *ngIf="isMultiSelectOptionSelected(item, option, $any(item.value).uniqueIdField || $any(item.value).valueField)"
                          src="assets/images/checkbox-marked.svg" class="daf-multiselect-checkbox" alt="">
                        <span>{{ option[$any(item.value).textField] || option.label || option.text || option }}</span>
                      </li>
                      <li *ngIf="filterMultiSelectOptions(item.value, $any(item.value).searchText).length === 0"
                        class="daf-multiselect-no-results">
                        No results found
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="daf-table-wrap"
                  *ngIf="item.value && $any(item.value).type && $any(item.value).type == 'table'">
                  <table class="daf-modal-table">
                    <thead>
                      <tr>
                        <th *ngFor="let col of $any(item.value).columns"
                          [ngStyle]="{'text-align':(col.type == 'checkbox')?'center':''}">
                          {{col.label||''}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of dataHash[$any(item).key]">
                        <td *ngFor="let col of $any(item.value).columns">
                          <div *ngIf="col.type == 'label'">{{row[col.key]}}</div>
                          <input [disabled]="readonly" type="checkbox" [(ngModel)]="row[col.key]" [value]="row[col.key] || row.default"
                            *ngIf="col.type == 'checkbox'" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div *ngIf="formErrors[$any(item).key]" class="daf-form-error">{{formErrors[$any(item).key]}}</div>
            </div>
          </ng-container>

        </div>
      </ng-container>
      <ng-container *ngIf="selectedTabType == 'conditions'">
        <div class="daf-conditions-panel">
          <div class="daf-conditions-list" *ngIf="dataHash.conditions?.length">
            <div class="daf-condition-block" *ngFor="let data of dataHash.conditions; let i = index; let isLast = last">
              <!-- Saved condition -->
              <ng-container *ngIf="!data.editing">
                <div class="daf-condition-join" *ngIf="shouldShowJoinOperator(i)">
                  <span class="daf-condition-join-line"></span>
                  <span class="daf-condition-join-badge" [class.is-and]="getJoinOperatorForIndex(i) === '$and'"
                    [class.is-or]="getJoinOperatorForIndex(i) !== '$and'">
                    {{ getJoinOperatorForIndex(i) === '$and' ? 'AND' : 'OR' }}
                  </span>
                  <span class="daf-condition-join-line"></span>
                </div>

                <div class="daf-condition-card">
                  <div class="daf-condition-card-body">
                    <span class="daf-condition-chip daf-condition-chip--lhs">{{ data.lhs }}</span>
                    <span class="daf-condition-chip daf-condition-chip--op">{{ data.operatorDetail?.symbol }}</span>
                    <span class="daf-condition-chip daf-condition-chip--rhs">{{ data.rhs }}</span>
                  </div>
                  <div class="daf-condition-card-actions">
                    <button [disabled]="readonly" type="button" class="daf-icon-btn" title="Edit" (click)="editRule(i)">
                      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
                      </svg>
                    </button>
                    <button [disabled]="readonly" type="button" class="daf-icon-btn daf-icon-btn--danger" title="Delete"
                      (click)="deleteRule(i)">
                      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- Condition editor -->
              <div class="daf-condition-editor" *ngIf="data.editing && !readonly">
                <div class="daf-condition-join" *ngIf="shouldShowJoinOperator(i)">
                  <span class="daf-condition-join-line"></span>
                  <div class="daf-join-toggle">
                    <button type="button" [class.active]="getJoinOperatorForIndex(i) !== '$and'"
                      (click)="onJoinOperatorChange('$or', i)">OR</button>
                    <button type="button" [class.active]="getJoinOperatorForIndex(i) === '$and'"
                      (click)="onJoinOperatorChange('$and', i)">AND</button>
                  </div>
                  <span class="daf-condition-join-line"></span>
                </div>

                <div class="daf-condition-editor-card">
                  <div class="daf-condition-editor-title">
                    {{ isEditingExistCondition(data, i) ? 'Edit condition' : 'Add condition' }}
                  </div>

                  <div class="daf-condition-fields">
                    <div class="daf-condition-field daf-condition-field--full">
                      <label class="daf-condition-field-label">Field</label>
                      <div class="custom-dropdown" [class.open]="isDropdownOpen('cond-lhs-' + i)"
                        [class.has-value]="!!data.unique_id">
                        <button type="button" class="custom-dropdown-toggle"
                          (click)="toggleDropdown('cond-lhs-' + i, $event)">
                          <span class="custom-dropdown-label" [class.is-placeholder]="!data.unique_id">{{
                            getDropdownLabel(getConditionLhsOptions(), data.unique_id, 'Select field') }}</span>
                          <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                        </button>
                        <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('cond-lhs-' + i)">
                          <li class="custom-dropdown-item custom-dropdown-item--placeholder"
                            [class.active]="!data.unique_id"
                            (click)="onCustomSelect('cond-lhs-' + i, '', 'conditionLhs', i); $event.stopPropagation()">
                            Select field
                          </li>
                          <li class="custom-dropdown-item" *ngFor="let field of getConditionLhsOptions()"
                            [class.active]="data.unique_id === field.id"
                            (click)="onCustomSelect('cond-lhs-' + i, field.id, 'conditionLhs', i); $event.stopPropagation()">
                            <span class="custom-dropdown-item-text">{{ field.name }}</span>
                            <span class="custom-dropdown-check" *ngIf="data.unique_id === field.id"
                              aria-hidden="true">✓</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="daf-condition-field" *ngIf="data.isSubLHSEnabled">
                      <label class="daf-condition-field-label">Sub field</label>
                      <div class="custom-dropdown" [class.open]="isDropdownOpen('cond-sublhs-' + i)"
                        [class.disabled]="!data.unique_id || data.unique_id == ''"
                        [class.has-value]="!!data.field_id_value">
                        <button type="button" class="custom-dropdown-toggle"
                          [disabled]="!data.unique_id || data.unique_id == ''"
                          (click)="data.unique_id && toggleDropdown('cond-sublhs-' + i, $event)">
                          <span class="custom-dropdown-label" [class.is-placeholder]="!data.field_id_value">{{
                            getDropdownLabel(getConditionSubLhsOptions(data), data.field_id_value, 'Select sub field')
                            }}</span>
                          <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                        </button>
                        <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('cond-sublhs-' + i)">
                          <li class="custom-dropdown-item custom-dropdown-item--placeholder"
                            [class.active]="!data.field_id_value"
                            (click)="onCustomSelect('cond-sublhs-' + i, '', 'conditionSubLhs', i, data.unique_id); $event.stopPropagation()">
                            Select sub field
                          </li>
                          <li class="custom-dropdown-item" *ngFor="let field of getConditionSubLhsOptions(data)"
                            [class.active]="data.field_id_value == field.id"
                            (click)="onCustomSelect('cond-sublhs-' + i, field.id, 'conditionSubLhs', i, data.unique_id); $event.stopPropagation()">
                            <span class="custom-dropdown-item-text">{{ field.name }}</span>
                            <span class="custom-dropdown-check" *ngIf="data.field_id_value == field.id"
                              aria-hidden="true">✓</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="daf-condition-field">
                      <label class="daf-condition-field-label">Operator</label>
                      <div class="custom-dropdown" [class.open]="isDropdownOpen('cond-op-' + i)"
                        [class.has-value]="!!data.operator_id">
                        <button type="button" class="custom-dropdown-toggle"
                          (click)="toggleDropdown('cond-op-' + i, $event)">
                          <span class="custom-dropdown-label" [class.is-placeholder]="!data.operator_id">{{
                            getDropdownLabel(getConditionOperatorOptions(data), data.operator_id, 'Select operator')
                            }}</span>
                          <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                        </button>
                        <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('cond-op-' + i)">
                          <li class="custom-dropdown-item custom-dropdown-item--placeholder"
                            [class.active]="!data.operator_id"
                            (click)="onCustomSelect('cond-op-' + i, '', 'conditionOperator', i); $event.stopPropagation()">
                            Select operator
                          </li>
                          <li class="custom-dropdown-item" *ngFor="let operator of getConditionOperatorOptions(data)"
                            [class.active]="data.operator_id === operator.id"
                            (click)="onCustomSelect('cond-op-' + i, operator.id, 'conditionOperator', i); $event.stopPropagation()">
                            <span class="custom-dropdown-item-text">{{ operator.name }}</span>
                            <span class="custom-dropdown-check" *ngIf="data.operator_id === operator.id"
                              aria-hidden="true">✓</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="daf-condition-field">
                      <label class="daf-condition-field-label">Value</label>
                      <div class="custom-dropdown" *ngIf="data.rhsHasPossibleValue"
                        [class.open]="isDropdownOpen('cond-val-' + i)" [class.has-value]="!!data.value">
                        <button type="button" class="custom-dropdown-toggle"
                          (click)="toggleDropdown('cond-val-' + i, $event)">
                          <span class="custom-dropdown-label" [class.is-placeholder]="!data.value">{{
                            getDropdownLabel(getConditionValueOptions(data), data.value, 'Select value') }}</span>
                          <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                        </button>
                        <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('cond-val-' + i)">
                          <li class="custom-dropdown-item custom-dropdown-item--placeholder"
                            [class.active]="!data.value"
                            (click)="onCustomSelect('cond-val-' + i, '', 'conditionValue', i, data); $event.stopPropagation()">
                            Select value
                          </li>
                          <li class="custom-dropdown-item" *ngFor="let option of getConditionValueOptions(data)"
                            [class.active]="data.value == option.id"
                            (click)="onCustomSelect('cond-val-' + i, option.id, 'conditionValue', i, data); $event.stopPropagation()">
                            <span class="custom-dropdown-item-text">{{ option.name }}</span>
                            <span class="custom-dropdown-check" *ngIf="data.value == option.id"
                              aria-hidden="true">✓</span>
                          </li>
                        </ul>
                      </div>
                      <input [disabled]="readonly" class="form-input" type="text" [(ngModel)]="data.value" placeholder="Enter value..."
                        *ngIf="!data.rhsHasPossibleValue" (change)="onValueChange($event, data, i)">
                    </div>
                  </div>

                  <div class="daf-condition-editor-footer">
                    <button type="button" class="daf-btn daf-btn--ghost" (click)="clearCondition(i)">Clear</button>
                    <button type="button" class="daf-btn daf-btn--primary" (click)="addRule(i)"
                      [disabled]="!isConditionComplete(data)">
                      {{ isEditingExistCondition(data, i) ? 'Update' : 'Add' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedTabType == 'actions'">
        <dynamic-form-action-setup [readonly]="readonly" [workflow]="dataHash"></dynamic-form-action-setup>
      </ng-container>
    </div>
  </div>
  <div class="daf-modal-footer">
    <!-- Section Navigation Buttons -->
    <div *ngIf="sections.length > 1" class="daf-section-buttons">
      <button type="button" class="btn-back" [disabled]="isFirstSection()" (click)="previousSection()">
        Back
      </button>
      <button type="button" class="btn-next" *ngIf="!isLastSection()" (click)="nextSection()"
        [disabled]="selectedTabType === 'conditions' && hasPartialConditions()">
        Next
      </button>
      <button type="submit" class="btn-save" *ngIf="isLastSection()" (click)="submitForm()"
        [disabled]="readonly || hasPartialConditions()">
        {{ submitLabel || 'Save' }}
      </button>
    </div>

    <!-- Standard form actions (when no sections) -->
    <div *ngIf="sections.length <= 1" class="daf-standard-actions">
      <button type="button" [disabled]="readonly" class="btn-cancel" (click)="resetForm()">{{ resetLabel ||
        'Reset' }}</button>
      <button type="submit" class="btn-save" (click)="submitForm()" [disabled]="readonly || hasPartialConditions()">{{ submitLabel
        || 'Submit'
        }}</button>
    </div>
  </div>
</div>